import { render, staticRenderFns } from "./JourneyConnectionAction.vue?vue&type=template&id=b5943d78&"
import script from "./JourneyConnectionAction.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5943d78')) {
      api.createRecord('b5943d78', component.options)
    } else {
      api.reload('b5943d78', component.options)
    }
    module.hot.accept("./JourneyConnectionAction.vue?vue&type=template&id=b5943d78&", function () {
      api.rerender('b5943d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionAction.vue"
export default component.exports